/**Расширения видео */
export const videoExtensitons = ["avi", "mp4", "mkv", "mov", "flv", "webm"];
